import { ReactNode } from 'react';

interface PrintableReportHeaderProps {
	children: ReactNode;
	bottomMargin?: string;
	className?: string;
	logoClassName?: string;
}

const printableMerlinLogo = '/merlin-logo.svg';
const printableSurgicalDirectionsLogo = '/Surgical_Directions_Logo.svg';

export function PrintableReportHeader({
	children,
	bottomMargin = 'mb-16',
	className = '',
	logoClassName = 'h-16',
}: PrintableReportHeaderProps) {
	return (
		<div className={`grid grid-cols-[1fr_auto_1fr] items-center gap-8 ${bottomMargin} bg-white px-1 py-1 ${className}`}>
			<img className={`${logoClassName} w-auto justify-self-start`} src={printableMerlinLogo} alt='The Merlin logo.' />

			<div className='text-center'>{children}</div>

			<img
				className={`${logoClassName} w-auto justify-self-end`}
				src={printableSurgicalDirectionsLogo}
				alt='Surgical Directions logo.'
			/>
		</div>
	);
}
